export const business = 'coppel-hdi';
export const insurance = "hdi";
